import {Component, OnDestroy, OnInit} from '@angular/core';
import {DetailConfiguration} from "../../../models/detail-configuration";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
	selector: 'tig-reduced-detail',
	templateUrl: './reduced-detail.component.html',
	styleUrls: ['./reduced-detail.component.scss']
})
export class ReducedDetailComponent implements OnInit, OnDestroy
{

	private ARR_subscriptions: Subscription[] = [Subscription.EMPTY];

	public OBJ_detail_config: DetailConfiguration;

	constructor(
		private OBJ_activate_route: ActivatedRoute,
		private OBJ_router: Router,
	)
	{
		// Lade Daten neu, sobald Routernavigation beendet ist (nicht an params festgemacht, da nach speichern reload auf selbe route ausgeloest wird)
		this.ARR_subscriptions.push(this.OBJ_router.events.subscribe(
			event => {
				// Einhaengen, sobald Navigation erfolgreich beendet ist
				if (event instanceof NavigationEnd)
				{
					this.initializeData();
				} // end if

			}));
	}

	ngOnInit()
	{
	}


	/**
	 * Function > initializeData
	 */
	initializeData()
	{
		// Konfiguration (und darin die Daten) der Detailansicht aus Daten des Resolvers holen
		this.OBJ_detail_config = this.OBJ_activate_route.snapshot.data.OBJ_detail_config;

	} // end function initializeData

	/**
	 * LifecycleHook > ngOnDestroy
	 */
	ngOnDestroy()
	{

		// Unsubscribe from all subscriptions to prevent memory leak
		this.ARR_subscriptions.forEach(
			(OBJ_subscription: Subscription) => { OBJ_subscription.unsubscribe(); }
		);

	} // end LifecycleHook ngOnDestroy

}
